const Contact = () => {
  return <p>contact us</p>
}

export default Contact
